import { nextTick } from 'vue';
// 用于给a-select组件选中框超出tooltip显示
// 要监听组件的mouseenter、mouseleave，并将插槽label的根节点设置为EllipsisTooltip组件
// 当select组件使用搜索功能时，如果已选项超过一行，点击select框时会变成一行，导致select框大小发生变化，此时如果select框在table组件并有fixed功能时会造成table高度变化，导致与fixed表格对不齐，所以将select框设定为一行并tooltip提示来解决这种大小变化问题
export const handleSelectEllipsisTooltipMouse = (
  e: any,
  mouseType: 'mouseenter' | 'mouseleave'
) => {
  const ellipsisTooltipEl = e?.target?.querySelector(
    '.arco-select-view-value'
  )?.firstElementChild;
  if (!ellipsisTooltipEl?.className?.includes('qs-ellipsis-tooltip')) return;
  // 给a-tooltip组件的根元素指派一个MouseEvent事件用来触发tooltip
  ellipsisTooltipEl?.firstElementChild?.dispatchEvent(
    new MouseEvent(mouseType, {
      bubbles: true, // 是否冒泡
      cancelable: true, // 是否可取消默认行为
    })
  );
};

// 使下拉框获取焦点，需要v-model绑定popupVisible属性
export const focusSelect = (selectRef: any, visible = true) => {
  nextTick(async () => {
    // 设置下拉框
    await selectRef?.$emit('update:popupVisible', visible);
    await selectRef?.$emit('popupVisibleChange', visible);
    const selectInput = selectRef?.$el?.nextElementSibling?.querySelector(
      '.arco-select-view-input'
    );
    // 使a-select自身的搜索框聚焦
    if (visible) {
      selectInput?.focus();
    }
  });
};
export default {};
